import { type ToursListExEntity } from '../..'

/**
 * 運行実績ステータス
 *
 * 画面に出す名前は見る立場で変わるため、features/approval-workflow/models の
 * getChargeStatusLabel で引く
 */
export type ChargeStatusType = ToursListExEntity['status']

export const CHARGE_STATUS_TYPE = {
  /** センター事前入力 */
  DC_PRE_ENTRY: 'DC_PRE_ENTRY',
  /** パートナー確認中 */
  PARTNER_PENDING: 'PARTNER_PENDING',
  /** 確認待ち */
  DC_PENDING: 'DC_PENDING',
  /** 確定済 */
  CONFIRMED: 'CONFIRMED',
  /** パートナー再確認待ち（差し戻し） */
  REJECTED: 'REJECTED'
} as const satisfies Record<ChargeStatusType, ChargeStatusType>
